module.exports = __webpack_public_path__ + "img/gas.56fdf06.svg";